/**
 * Boot Pullback (Valid Pullback Flow) — adaptación frontend-only de la
 * lógica "Valid Pullback Flow": zigzag estructural con retrocesos válidos,
 * rupturas BOS/CHoCH, niveles Ext/Int y máquina de flujo long/short.
 *
 * Cálculo 100% cliente (detect sobre las velas del chart); pintura 100%
 * canvas vía una única custom series. Sin backend.
 */

import BadgeComponent from './Badge.jsx'
import PanelComponent from './Panel.jsx'
import { SAFE_DEFAULTS, resolveConfig } from './constants.js'
import { compute } from './engine.js'
import { renderBootPullback } from './renderer.js'

export const defaultConfig = SAFE_DEFAULTS

export function detect(candles, config) {
  const cfg = resolveConfig(config)
  return compute(Array.isArray(candles) ? candles : [], cfg)
}

export function render(chart, candleSeries, result, config, api) {
  renderBootPullback(chart, candleSeries, result, config, api)
}

export default {
  id: 'boot_pullback',
  name: 'Boot Pullback',
  version: '1.0.0',
  // El dibujo es una custom series nativa de LWC: la repinta el propio chart
  // en cada frame de pan/zoom, no depende del viewport (opt-out como LPQ/OB/MB).
  renderOnPan: false,
  defaultConfig,
  detect,
  render,
  BadgeComponent,
  PanelComponent,
}
